import EntityRating from './EntityRating'

export default EntityRating
